import { ENDPOINTS } from '../../network/endpoints';

/** @implements {import('../../../contracts/IDashboardRepository').IDashboardRepository} */
export class DashboardRepository {
  /** @param {import('../../../contracts/IHttpClient').IHttpClient} client */
  constructor(client) {
    this.client = client;
  }

  async getDashboardAnalytics(dateRange = '30d') {
    return this.client.get(ENDPOINTS.DASHBOARD.ANALYTICS, {
      params: { range: dateRange },
    });
  }

  async getSubscription() {
    return this.client.get(ENDPOINTS.DASHBOARD.SUBSCRIPTION);
  }

  async getSettings() {
    return this.client.get(ENDPOINTS.DASHBOARD.SETTINGS);
  }

  async updateSettings(settings) {
    return this.client.patch(ENDPOINTS.DASHBOARD.SETTINGS, settings);
  }
}
